(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mrc-category-tiles"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-mrc-category-tiles]:not([data-mrc-category-tiles-ready])').forEach(function (root) {
    root.setAttribute('data-mrc-category-tiles-ready', 'true');

    function hydrateTile(target) {
      var tile = target.closest('.mrc-category-tile--has-hover');
      if (!tile || !root.contains(tile)) return;
      var image = tile.querySelector('img[data-mrc-tile-src]');
      if (!image) return;
      if (image.dataset.mrcTileSrcset) image.srcset = image.dataset.mrcTileSrcset;
      image.src = image.dataset.mrcTileSrc;
      image.removeAttribute('data-mrc-tile-src');
      image.removeAttribute('data-mrc-tile-srcset');
    }

    root.addEventListener('pointerover', function (event) { hydrateTile(event.target); }, { passive: true });
    root.addEventListener('focusin', function (event) { hydrateTile(event.target); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mrc-home-mosaic"] && !Shopify.designMode) return;
  try {
    
(function(){
  var videos = document.querySelectorAll('[data-mrc-lazy-video]:not([data-mrc-video-ready])');
  if (!videos.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  function play(video) {
    video.setAttribute('data-mrc-video-ready', 'true');
    if (video.closest('.mrc-mosaic__tile--video-lg')) {
      video.addEventListener('playing', function () {
        video.closest('.mrc-mosaic__tile').setAttribute('data-mrc-video-playing', 'true');
      }, { once: true });
    }
    var promise = video.play();
    if (promise && promise.catch) promise.catch(function(){});
  }
  if (!('IntersectionObserver' in window)) {
    videos.forEach(play);
    return;
  }
  var observer = new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if (!entry.isIntersecting) return;
      play(entry.target);
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '200px 0px' });
  videos.forEach(function(video){ observer.observe(video); });
})();

  } catch(e) { console.error(e); }
})();
})();
